module.exports = __webpack_public_path__ + "img/couples-007.fa971da2.jpg";